module.exports = __webpack_public_path__ + "img/icon-loader3.6ac5b882.svg";